enum FILTER_PAGE {
  INDISPONIBILITE_TEMPORAIRE,
  TOURNEE,
  PEI_LONGUE_INDISPO,
}
export default FILTER_PAGE;
